export default "__VITE_ASSET__C_WBdU4j__"